import { xCore } from './core';
import { NSServerCalls } from './utils/servercalls';
import { URN } from './utils/urn';
import { NSMessages } from './utils/messages'

export const NSObjDetailsCloneData = {};

NSObjDetailsCloneData.init = function () {
    NSObjDetailsCloneDataPrivate.init();

    this.f_get_config = function () { return NSObjDetailsCloneDataPrivate.f_get_config.apply( NSObjDetailsCloneDataPrivate, arguments ); };
    this.f_is_eligible = function () { return NSObjDetailsCloneDataPrivate.f_is_eligible.apply( NSObjDetailsCloneDataPrivate, arguments ); };
    this.f_store_data = function () { return NSObjDetailsCloneDataPrivate.f_store_data.apply( NSObjDetailsCloneDataPrivate, arguments ); };
    this.f_get_store_data = function () { return NSObjDetailsCloneDataPrivate.f_get_store_data.apply( NSObjDetailsCloneDataPrivate, arguments ); };
    this.f_get_store_data_config = function () { return NSObjDetailsCloneDataPrivate.f_get_store_data_config.apply( NSObjDetailsCloneDataPrivate, arguments ); };
    this.f_get_store_data_parent_urn = function () { return NSObjDetailsCloneDataPrivate.f_get_store_data_parent_urn.apply( NSObjDetailsCloneDataPrivate, arguments ); };
    this.f_execute_paste = function () { return NSObjDetailsCloneDataPrivate.f_execute_paste.apply( NSObjDetailsCloneDataPrivate, arguments ); };
}

const NSObjDetailsCloneDataPrivate = {
    module: "NSObjDetailsCloneData",
    eligibleCollections: [],
    clipboard: undefined,
    init: function () {
        this.eligibleCollections = xCore.modules[this.module].settings.eligibleCollections;
    },
    f_get_config: function(urn) {
        const dataset = URN.f_get_urn_schema_name(urn);
        const collection = URN.f_get_urn_table_name(urn);

        for (const eligible of this.eligibleCollections) {
            if (eligible['dataset'] !== dataset) continue;
            if (eligible['collection'] !== collection) continue;
            
            return eligible;
        }

        return null;
    },
    f_is_eligible: function (urn) {
        return this.f_get_config(urn) !== null;
    },
    f_store_data: function (data) {
        const { parentCollection } = this.f_get_config(data.table_urn);
        const input_params = data.input_params.filter(el => el.name !== `${parentCollection}_id`);
        this.clipboard = {...data, input_params};
    },
    f_get_store_data: function () {
        return this.clipboard;
    },
    f_get_store_data_config: function () {
        const table_urn = this.clipboard ? this.clipboard.table_urn : undefined;

        if (undefined) return;

        return this.f_get_config(table_urn);
    },
    f_get_store_data_parent_urn: function() {
        const table_urn = this.clipboard ? this.clipboard.table_urn : undefined;

        if (!table_urn) return;

        const {dataset, parentCollection} = this.f_get_config(table_urn);

        return URN.f_create_table_urn(dataset, parentCollection);
    },
    f_execute_paste: async function(features) {
        const store_data = this.f_get_store_data();
        
        const { dataset, collection, parentCollection } = this.f_get_store_data_config();
        const table_urn = URN.f_create_table_urn(dataset, collection);
        const promises = [];
        let errors = false;
        
        for (const {id, bbox} of features) {
            try {
                promises.push(NSServerCalls.f_edit_obj_upsert({
                    table_urn,
                    input_params: [
                        ...store_data.input_params,
                        { name: `${parentCollection}_id`, value: id },
                    ],
                    update_tiles: {
                        b_update_tiles: true,
                        a_bounds_list: [{ 
                            x_min: bbox[0], 
                            y_min: bbox[1], 
                            x_max: bbox[2], 
                            y_max: bbox[3] 
                        }],
                    },
                    operation: 'upsert',
                    output_params: [{ name: 'id', value: null }],
                }, () => {}));
            } catch(err) {
                errors = true;
                console.log(err.message);
            }
        }

        await Promise.all(promises);

        NSMessages.f_show_success(`<div>Foram inseridos ${features.length} novos registos com sucesso</div>`, 5000);
    }
};
